import React, { useState } from "react";
import { Button, Drawer, TextField } from "@material-ui/core";
import { AiFillCloseCircle } from "react-icons/ai";
import ReactStars from "react-rating-stars-component";

import "./index.css";
import { api_call_token } from "../../utils/Network";
import { isMobiledevice } from "../../utils/helperFunctions";

export default function ReviewPopup({
  serviceId = 0,
  show = false,
  setMsg = () => {},
  onClose = () => {},
}) {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");

  const postReview = () => {
    if (rating) {
      api_call_token
        .post("auth/ratings/post_review/", {
          service_id: serviceId,
          feedback: feedback,
          rating: rating,
        })
        .then(
          (r) => (
            setMsg(
              r.status === 200
                ? "Review submitted successfully"
                : "Review already submitted !"
            ),
            onClose()
          )
        )
        .catch((e) => console.log(e));
    } else setMsg("Please select rating !");
  };

  return (
    <Wrapper show={show} onClose={() => onClose()}>
      <div className="review-container">
        <div className="review-header">Submit Review</div>
        <div
          style={{ display: "flex", alignItems: "center", margin: "10px 0" }}
        >
          <p style={{ marginBottom: 10, marginRight: 30, color: "#666" }}>
            Rating:{" "}
          </p>
          <ReactStars
            count={5}
            onChange={(v) => setRating(v)}
            size={28}
            activeColor="#ffd700"
            value={rating}
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <p style={{ marginTop: 0, marginRight: 10, color: "#666" }}>
            Feedback:{" "}
          </p>
          <TextField
            minRows={3}
            variant="outlined"
            maxRows={5}
            placeholder="Describe Your Experience"
            onChange={(e) => setFeedback(e.target.value)}
            style={{ width: "100%" }}
            size="small"
            multiline
          />
        </div>
        <Button onClick={postReview} className="review-btn">
          Submit Review
        </Button>
      </div>
    </Wrapper>
  );
}

const Wrapper = ({ show, onClose, children }) =>
  isMobiledevice() ? (
    <Drawer
      PaperProps={{
        style: { borderTopRightRadius: 25, borderTopLeftRadius: 25 },
      }}
      open={show}
      onClose={onClose}
      anchor="bottom"
    >
      {children}
    </Drawer>
  ) : (
    <Modal show={show} onClose={onClose}>
      {children}
    </Modal>
  );

const Modal = ({ modalStyle, show, onClose, children, backdropStyle }) => {
  return (
    <React.Fragment>
      <div style={backdropStyle} className={show ? "modal visible" : "modal"}>
        <div
          style={{
            width: 60,
            height: 40,
            position: "absolute",
            top: 0,
            right: 0,
            margin: "1rem",
            cursor: "pointer",
          }}
          className="close__btn"
        >
          <AiFillCloseCircle onClick={onClose} className="close-icon" />
        </div>
        <div style={modalStyle} className="modal__wrap">
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};
